import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line import/no-extraneous-dependencies
import { SET_ITEM, SET_ITEMS, GET_ONE, GET_LIST, CREATE, CREATE_MANY, UPLOAD, UPDATE, DELETE, DELETE_MANY_POST, UPDATE_MANY, UPDATE_MANY_POST, RESET, RESET_CRUD_ERROR, UPLOAD_MANY } from './constants';

var generator = function generator(_ref) {
  var resource = _ref.resource,
      _ref$surchargeAction = _ref.surchargeAction,
      surchargeAction = _ref$surchargeAction === void 0 ? function () {
    return {};
  } : _ref$surchargeAction,
      _ref$chunkUrlResource = _ref.chunkUrlResource,
      chunkUrlResource = _ref$chunkUrlResource === void 0 ? resource : _ref$chunkUrlResource,
      scope = _ref.scope,
      _ref$disableConcurren = _ref.disableConcurrency,
      disableConcurrency = _ref$disableConcurren === void 0 ? {} : _ref$disableConcurren,
      version = _ref.version;
  var common = {
    resource: resource,
    chunkUrlResource: chunkUrlResource,
    scope: scope,
    version: version,
    onSuccess: undefined,
    onError: undefined
  };
  var actions = {
    sendAction: function sendAction(action) {
      return action;
    },
    setItem: function setItem(item, nextActions) {
      return _objectSpread(_objectSpread({}, common), {}, {
        type: SET_ITEM,
        nextActions: nextActions,
        payload: {
          item: item
        }
      });
    },
    setItems: function setItems(items, nextActions) {
      return _objectSpread(_objectSpread({}, common), {}, {
        type: SET_ITEMS,
        nextActions: nextActions,
        payload: {
          items: items
        }
      });
    },
    getOne: function getOne(id, params, nextActions) {
      var target = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'item';
      return _objectSpread(_objectSpread({}, common), {}, {
        type: disableConcurrency.isGetOneDisableConcurrency ? "".concat(GET_ONE, "/").concat(resource) : GET_ONE,
        target: target,
        payload: {
          id: id,
          params: params
        },
        nextActions: nextActions
      });
    },
    getOneWithCompositeKey: function getOneWithCompositeKey(params, nextActions) {
      return _objectSpread(_objectSpread({}, common), {}, {
        type: disableConcurrency.isGetOneDisableConcurrency ? "".concat(GET_ONE, "/").concat(resource) : GET_ONE,
        payload: {
          params: params
        },
        nextActions: nextActions
      });
    },
    getList: function getList(params) {
      var isReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var nextActions = arguments.length > 2 ? arguments[2] : undefined;
      var chunkId = arguments.length > 3 ? arguments[3] : undefined;
      var chunkResource = arguments.length > 4 ? arguments[4] : undefined;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: disableConcurrency.isGetListDisableConcurrency ? "".concat(GET_LIST, "/").concat(resource) : GET_LIST,
        isReplace: isReplace,
        payload: params,
        nextActions: nextActions,
        chunkId: chunkId,
        chunkResource: chunkResource
      });
    },
    updateMany: function updateMany(items, params, nextActions) {
      return _objectSpread(_objectSpread({}, common), {}, {
        type: UPDATE_MANY,
        nextActions: nextActions,
        payload: {
          items: items,
          params: params
        }
      });
    },
    updateManyPost: function updateManyPost(props) {
      var items = props.items,
          _props$nextActions = props.nextActions,
          nextActions = _props$nextActions === void 0 ? [] : _props$nextActions,
          _props$params = props.params,
          params = _props$params === void 0 ? {} : _props$params,
          chunkId = props.chunkId,
          chunkResource = props.chunkResource;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: UPDATE_MANY_POST,
        nextActions: nextActions,
        chunkId: chunkId,
        chunkResource: chunkResource,
        payload: {
          items: items,
          params: params
        }
      });
    },
    // WARNING: the result will be { ...action.payload, ...item } where
    // action.payload is the api return and item the store Object
    // with this method we keep agregations and other selecter or next update (with delay)
    // BUT !!
    // if you want update a object by removing a attribut you have to call setItem/setItems
    // with the updated object/array
    // because the value store will always have the last word
    // in benefit the user will see the update immediately
    updateOne: function updateOne(data) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextActions = arguments.length > 2 ? arguments[2] : undefined;
      var chunkId = arguments.length > 3 ? arguments[3] : undefined;
      var chunkResource = arguments.length > 4 ? arguments[4] : undefined;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: UPDATE,
        params: params,
        // TODO: params in payload or in action but not both
        nextActions: nextActions,
        chunkId: chunkId,
        chunkResource: chunkResource,
        payload: {
          data: data,
          id: data.id,
          params: params
        }
      });
    },
    upload: function upload(data) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextActions = arguments.length > 2 ? arguments[2] : undefined;
      var chunkId = arguments.length > 3 ? arguments[3] : undefined;
      var chunkResource = arguments.length > 4 ? arguments[4] : undefined;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: UPLOAD,
        chunkId: chunkId,
        chunkResource: chunkResource,
        nextActions: nextActions,
        payload: {
          data: data,
          params: params
        }
      });
    },
    uploadMany: function uploadMany(data) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextActions = arguments.length > 2 ? arguments[2] : undefined;
      var chunkId = arguments.length > 3 ? arguments[3] : undefined;
      var chunkResource = arguments.length > 4 ? arguments[4] : undefined;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: UPLOAD_MANY,
        chunkId: chunkId,
        chunkResource: chunkResource,
        nextActions: nextActions,
        payload: {
          data: data,
          params: params
        }
      });
    },
    create: function create(data) {
      var isListDst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var nextActions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var chunkId = arguments.length > 4 ? arguments[4] : undefined;
      var chunkResource = arguments.length > 5 ? arguments[5] : undefined;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: CREATE,
        isListDst: isListDst,
        nextActions: nextActions,
        chunkId: chunkId,
        chunkResource: chunkResource,
        payload: {
          data: data,
          params: params
        }
      });
    },
    createMany: function createMany(items, nextActions) {
      return _objectSpread(_objectSpread({}, common), {}, {
        type: CREATE_MANY,
        nextActions: nextActions,
        payload: {
          items: items
        }
      });
    },
    delete: function _delete(id) {
      var nextActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _objectSpread(_objectSpread({}, common), {}, {
        type: DELETE,
        nextActions: nextActions,
        payload: {
          id: id,
          params: params
        }
      });
    },
    deleteManyPost: function deleteManyPost(props) {
      var ids = props.ids,
          _props$nextActions2 = props.nextActions,
          nextActions = _props$nextActions2 === void 0 ? [] : _props$nextActions2,
          _props$params2 = props.params,
          params = _props$params2 === void 0 ? {} : _props$params2,
          chunkId = props.chunkId,
          chunkResource = props.chunkResource;
      return _objectSpread(_objectSpread({}, common), {}, {
        type: DELETE_MANY_POST,
        nextActions: nextActions,
        chunkId: chunkId,
        chunkResource: chunkResource,
        payload: {
          ids: ids,
          params: params
        }
      });
    },
    reset: function reset() {
      return {
        type: RESET,
        resource: resource
      };
    },
    resetError: function resetError() {
      return {
        type: RESET_CRUD_ERROR,
        resource: resource
      };
    }
  };
  var actionsOverloaded = Object.entries(actions).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    acc[key] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // eslint-disable-next-line no-console
      console.groupCollapsed('@@ActionCreator '.concat(resource, '.').concat(value.name, '(').concat(args.length > 0 ? JSON.stringify(args) : '', ')')); // eslint-disable-next-line no-console

      console.trace(); // eslint-disable-next-line no-console

      console.groupEnd(); // eslint-disable-next-line prefer-spread

      return value.apply(null, args);
    };

    return acc;
  }, {});
  var finalActions = process.env.NEXT_PUBLIC_LOG_REDUX_SAGA_ACTION === 'true' ? actionsOverloaded : actions;
  return _objectSpread(_objectSpread(_objectSpread({}, finalActions), surchargeAction(resource, chunkUrlResource)), {}, {
    resource: resource
  });
};

export default generator;
export var generationHelper = function generationHelper(actions) {
  var disableConcurrenciesGetOne = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var disableConcurrenciesGetList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return actions.map(function (action) {
    return generator(_objectSpread(_objectSpread({}, action), {}, {
      disableConcurrency: {
        isGetOneDisableConcurrency: disableConcurrenciesGetOne.includes(action.resource || ''),
        isGetListDisableConcurrency: disableConcurrenciesGetList.includes(action.resource || '')
      }
    }));
  });
};
//# sourceMappingURL=generator.js.map